import { ReactNode } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { tokens } from "../../theme";

/**
 * Tarjeta del Design Kit (§06): blanca, borde 1px, radio 8, padding 22.
 *
 * `deshabilitada` la deja a la vista pero inerte: se atenúa y deja de responder al
 * clic. Se usa cuando el contenido sigue siendo información —hay que poder leer qué
 * era— pero ya no lleva a ninguna acción.
 */
export function Tarjeta({
  children,
  onClick,
  deshabilitada = false,
}: {
  children: ReactNode;
  /** Recibe el evento: quien navega necesita ver Ctrl/⌘ para abrir en otra pestaña. */
  onClick?: (e: { ctrlKey?: boolean; metaKey?: boolean; shiftKey?: boolean; button?: number }) => void;
  deshabilitada?: boolean;
}) {
  const clicable = !!onClick && !deshabilitada;
  return (
    <Paper
      elevation={0}
      onClick={clicable ? onClick : undefined}
      onAuxClick={clicable ? onClick : undefined}
      aria-disabled={deshabilitada || undefined}
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "8px",
        padding: "22px",
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        cursor: clicable ? "pointer" : "default",
        opacity: deshabilitada ? 0.55 : 1,
        "&:hover": clicable ? { borderColor: tokens.azul[200] } : undefined,
      }}
    >
      {children}
    </Paper>
  );
}

/** Título de tarjeta: Poppins 700 / 18px (kit §06). */
export function TituloTarjeta({ children }: { children: ReactNode }) {
  return (
    <Box
      component={Typography}
      sx={{
        fontFamily: (t) => t.typography.h6.fontFamily,
        fontWeight: 700,
        fontSize: 18,
        lineHeight: 1.25,
        color: tokens.tabla.celdaFuerte,
      }}
    >
      {children}
    </Box>
  );
}
